import { useQuery } from "@tanstack/react-query";
import { getAppInventory } from "@/services/tenantsApi";
import { getTenantId } from "@/services/apiClient";
import { AppInventoryItem, AppVersion } from "@/types/inventory";
import { MdmDeviceApplication } from "@/types/api";

export const useAppInventory = () => {
  const tenantId = getTenantId();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['app-inventory', tenantId],
    queryFn: async () => {
      if (!tenantId) throw new Error('No tenant selected');

      const apps = await getAppInventory(tenantId);

      // Transform backend MdmDeviceApplication to UI AppInventoryItem
      const inventory: AppInventoryItem[] = apps.map((app: MdmDeviceApplication) => ({
        name: app.name,
        bundle_id: app.bundleId,
        icon: null,
        total_devices: app.deviceCount,
        versions: [
          {
            version: app.version || 'Unknown',
            device_count: app.deviceCount,
          } as AppVersion,
        ],
        first_seen: null,
        last_updated: null,
        is_managed: true,
      }));

      return inventory;
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    inventory: data || [],
    isLoading,
    error,
    refetch,
  };
};
